import { z } from 'zod';
import { addressLocationSchema, imageWithUploadSchema } from '../../common';
import { dateSchema, idSchema } from '../../validation';

export const orderImageTypesSchema = z.enum([
  'other_doc',
  'problem',
  'proof_of_pickup_doc',
  'proof_of_delivery_doc',
  'items',
  'place',
  'proof_of_arrival',
  'temperature',
  'vehicle',
  'other',
]);
export type OrderImageTypes = z.infer<typeof orderImageTypesSchema>;
export const orderImageSchema = z.object({
  /** the type of image such as proof_of_pickup_doc / proof_of_arrival / etc */
  type: orderImageTypesSchema,

  /** the location in which an image was added.
   *
   * If empty, then it means the this location was added manually
   */
  location: addressLocationSchema.optional(),
  /** the destination at which this image was taken */
  destinationId: idSchema.optional(),
  /** the taken image */
  image: imageWithUploadSchema,
  /** the date at which this image was taken */
  date: dateSchema,
  /**
   * The custom reference (customRef) is a unique identifier displayed on
   * POD (Proof of Delivery) or Proof of Pickup documents.
   *
   * It serves the following purposes:
   * - Enables efficient order lookup by either the customer's custom reference or our internal ID.
   *
   * This feature is especially useful for resolving user inquiries about their orders.
   */
  customRef: z.coerce.string().trim().optional(),
});



